import { render, staticRenderFns } from "./SkillAreas.vue?vue&type=template&id=f48db8dc&scoped=true&"
import script from "./SkillAreas.vue?vue&type=script&lang=js&"
export * from "./SkillAreas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48db8dc",
  null
  
)

export default component.exports